import api from './api-service';

const WebhookEndpointService = {
	list() {
		return api.client.get('/webhook-endpoints').then((res) => res.data);
	},

	create({ url, enabledEvents, description }) {
		return api.client
			.post('/webhook-endpoints', { url, enabledEvents, description })
			.then((res) => res.data);
	},

	update(id, changes) {
		return api.client.patch(`/webhook-endpoints/${id}`, changes).then((res) => res.data);
	},

	remove(id) {
		return api.client.delete(`/webhook-endpoints/${id}`);
	},

	rollSecret(id) {
		return api.client.post(`/webhook-endpoints/${id}/roll-secret`).then((res) => res.data);
	},

	deliveries(id) {
		return api.client.get(`/webhook-endpoints/${id}/deliveries`).then((res) => res.data);
	},

	retryDelivery(id) {
		return api.client.post(`/webhook-deliveries/${id}/retry`).then((res) => res.data);
	},

	eventTypes() {
		return api.client.get('/webhook-event-types').then((res) => res.data);
	}
};

export default WebhookEndpointService;
